// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatch.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BatchRecurrencePeriod, BatchRecurrencePeriodData, BatchRecurrencePeriodOptions } from 'data/models/BatchRecurrencePeriod';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Port, PortData, PortOptions } from 'data/models/Port';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { RecurringBatchChange, RecurringBatchChangeData, RecurringBatchChangeOptions } from 'data/models/RecurringBatchChange';
import { RecurringBatchSelf, RecurringBatchSelfData, RecurringBatchSelfOptions } from 'data/models/RecurringBatchSelf';
import { RecurringBatchVersion, RecurringBatchVersionData, RecurringBatchVersionOptions } from 'data/models/RecurringBatchVersion';

// RecurringBatchData is the class that RecurringBatch serializes to/from
export interface RecurringBatchData {
    Id : number;
    Url : string | null;
	
    Change : ChangeData | null;
    ChangeId : number;
    Changes : RecurringBatchChangeData[] | null;
    Port : PortData | null;
    PortCalls : PortCallData[] | null;
    PortId : number;
    Self : RecurringBatchSelfData | null;
    Version : RecurringBatchVersionData | null;
	
    Guid : /* GUID */ string;
    RecurrencePeriod : BatchRecurrencePeriodData;
    ReferenceNumber : string;
    RequestDate : /* ISO8601 */ string;
}

// RecurringBatchOptions is the class which may be passed to the RecurringBatch constructor to define optional initial data values
export interface RecurringBatchOptions {
    Id : number;
    Url? : string | null;
	
    Change? : ChangeOptions | null;
    ChangeId? : number;
    Changes? : RecurringBatchChangeOptions[] | null;
    Port? : PortOptions | null;
    PortCalls? : PortCallOptions[] | null;
    PortId? : number;
    Self? : RecurringBatchSelfOptions | null;
    Version? : RecurringBatchVersionOptions | null;
	
    Guid? : /* GUID */ string;
    RecurrencePeriod? : BatchRecurrencePeriodOptions;
    ReferenceNumber? : string;
    RequestDate? : /* ISO8601 */ string;
}

export class RecurringBatch {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public Changes : SDataArray<RecurringBatchChange>;
    public Port : DataSignal<Port | null>;
    public PortCalls : SDataArray<PortCall>;
    public PortId : DataSignal<number>;
    public Self : DataSignal<RecurringBatchSelf | null>;
    public Version : DataSignal<RecurringBatchVersion | null>;
	
    public Guid : DataSignal<string>;
    public RecurrencePeriod : BatchRecurrencePeriod;
    public ReferenceNumber : DataSignal<string>;
    public RequestDate : DataSignal<TZDate>;

    constructor();
    constructor(data : RecurringBatchOptions);
    constructor(data: RecurringBatchOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = SArray<RecurringBatchChange>([]);
        this.Port = S.value<Port | null>(null);
        this.PortCalls = SArray<PortCall>([]);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
        this.Self = S.value<RecurringBatchSelf | null>(null);
        this.Version = S.value<RecurringBatchVersion | null>(null);
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.RecurrencePeriod = data && data.RecurrencePeriod !== undefined ? new BatchRecurrencePeriod(data.RecurrencePeriod) : new BatchRecurrencePeriod();
        this.ReferenceNumber = jsonableObservable(S.value<string>(data && data.ReferenceNumber !== undefined ? data.ReferenceNumber : ''));
        this.RequestDate = jsonableObservable(S.value<TZDate>(data && data.RequestDate !== undefined ? new TZDate(data.RequestDate) : new TZDate(0), TZDate.eq));
    }

    static key(obj : RecurringBatch) {
        return obj.Id();
    }
    
    static dataKey(obj : RecurringBatchOptions) {
        return obj.Id;
    }

    static update(obj : RecurringBatch, data : RecurringBatchOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.RecurrencePeriod !== undefined) BatchRecurrencePeriod.update(obj.RecurrencePeriod, data.RecurrencePeriod);
            if (data.ReferenceNumber !== undefined) obj.ReferenceNumber(data.ReferenceNumber);
            if (data.RequestDate !== undefined) obj.RequestDate(new TZDate(data.RequestDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatch.ts